import JSCookie from 'js-cookie';

const COOKIE_VALID_DAYS = 1; // 0 = Session cookie

// Override the default js-cookie conversion / encoding
// methods so the written values work with Contensis sites
const Cookies = JSCookie.withConverter({
  read: value => decodeURIComponent(value),
  write: value => encodeURIComponent(value),
});

export class CookieHelper {
  static GetCookie(name: string) {
    const cookie = Cookies.get(name);
    return cookie;
  }

  static SetCookie(
    name: string,
    value: string,
    maxAgeDays = COOKIE_VALID_DAYS
  ) {
    if (maxAgeDays === 0) Cookies.set(name, value);
    else Cookies.set(name, value, { expires: maxAgeDays });
  }

  static DeleteCookie(name: string) {
    Cookies.remove(name);
  }
}
